import createDebug from 'debug';

export default (name: string) => createDebug(`app:shell:${name}`);
